import { NomadDB } from '~/db/NomadDB.js';
import type { AssessmentSchema } from '@/types/schema';

export const getAssessmentsService = (db: NomadDB) => {
  const findAll = async (): Promise<AssessmentSchema[]> => {
    return await db.assessments.toArray();
  };

  const findByLibraryBookIdAndMember = async (
    libraryBookId: string,
    memberId: string
  ): Promise<AssessmentSchema[]> => {
    if (!libraryBookId || !memberId) return [];
    const assessments = await db.assessments
      .where(['libraryBookId+member'])
      .anyOf([[libraryBookId, memberId]])
      .toArray();
    return assessments;
  };

  const findWhere = async (params: object): Promise<AssessmentSchema[]> => {
    return await db.assessments.where(params).toArray();
  };

  const findByMemberId = async (
    memberId: string
  ): Promise<AssessmentSchema[]> => {
    return await db.assessments.where({ member: memberId }).toArray();
  };

  const findByLibraryBookId = async (
    libraryBookId: string
  ): Promise<AssessmentSchema[]> => {
    return await db.assessments.where({ libraryBookId }).toArray();
  };

  const clearAndbulkPut = async (
    assessments: AssessmentSchema[]
  ): Promise<void> => {
    await db.assessments.clear();
    await db.assessments.bulkPut(assessments);
  };

  const put = async (params: AssessmentSchema): Promise<any> => {
    const p = JSON.parse(JSON.stringify(params));
    return await db.assessments.put(p);
  };

  return {
    findAll,
    clearAndbulkPut,
    findByLibraryBookIdAndMember,
    findByLibraryBookId,
    findByMemberId,
    put,
    findWhere,
  };
};
